import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from './commands-core'

export function useCloneCorporateScenarioCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	sourceId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	cloneName?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _sourceId = isRef<string>(sourceId) ? sourceId : ref<string>((typeof sourceId === 'function') ? sourceId() : sourceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _cloneName = isRef<string>(cloneName) ? cloneName : ref<string>((typeof cloneName === 'function') ? cloneName() : cloneName)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		sourceId: _sourceId,
		id: _id,
		cloneName: _cloneName,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof sourceId === 'function') { _sourceId.value = sourceId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof cloneName === 'function') { _cloneName.value = cloneName() }

			return new c.CloneCorporateScenarioCommandV1(_workspaceId.value, _strategyId.value, _sourceId.value, _id.value, _cloneName.value)
		})
	}

	return {
		...result,
		authorizedCloneCorporateScenarioCommandV1: result.authorized,
		cloneCorporateScenarioCommandV1: result.command,
		completedCloneCorporateScenarioCommandV1: result.completed,
		errorCloneCorporateScenarioCommandV1: result.error,
		invokeCloneCorporateScenarioCommandV1: result.invoke,
		invokingCloneCorporateScenarioCommandV1: result.invoking,
		succeedCloneCorporateScenarioCommandV1: result.succeed,
		validationErrorsCloneCorporateScenarioCommandV1: result.validationErrors,
		onSucceedCloneCorporateScenarioCommandV1: result.onSucceed,
	}
}

export function useCreateCorporateScenarioCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	planningStartDate?: any | Ref<any> | (() => any), 
	planningEndDate?: any | Ref<any> | (() => any), 
	denomination?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
	benefitsConfidenceDate?: any | null | Ref<any | null> | (() => any | null), 
	portfolioIds?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _planningStartDate = isRef<any>(planningStartDate) ? planningStartDate : ref<any>((typeof planningStartDate === 'function') ? planningStartDate() : planningStartDate)
	const _planningEndDate = isRef<any>(planningEndDate) ? planningEndDate : ref<any>((typeof planningEndDate === 'function') ? planningEndDate() : planningEndDate)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)
	const _benefitsConfidenceDate = isRef<any | null>(benefitsConfidenceDate) ? benefitsConfidenceDate : ref<any | null>((typeof benefitsConfidenceDate === 'function') ? benefitsConfidenceDate() : benefitsConfidenceDate)
	const _portfolioIds = isRef<any>(portfolioIds) ? portfolioIds : ref<any>((typeof portfolioIds === 'function') ? portfolioIds() : portfolioIds)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		planningStartDate: _planningStartDate,
		planningEndDate: _planningEndDate,
		denomination: _denomination,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,
		benefitsConfidenceDate: _benefitsConfidenceDate,
		portfolioIds: _portfolioIds,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof planningStartDate === 'function') { _planningStartDate.value = planningStartDate() }
			if (typeof planningEndDate === 'function') { _planningEndDate.value = planningEndDate() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }
			if (typeof benefitsConfidenceDate === 'function') { _benefitsConfidenceDate.value = benefitsConfidenceDate() }
			if (typeof portfolioIds === 'function') { _portfolioIds.value = portfolioIds() }

			return new c.CreateCorporateScenarioCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _planningStartDate.value, _planningEndDate.value, _denomination.value, _applyBenefitsConfidenceFactor.value, _benefitsConfidenceDate.value, _portfolioIds.value)
		})
	}

	return {
		...result,
		authorizedCreateCorporateScenarioCommandV1: result.authorized,
		createCorporateScenarioCommandV1: result.command,
		completedCreateCorporateScenarioCommandV1: result.completed,
		errorCreateCorporateScenarioCommandV1: result.error,
		invokeCreateCorporateScenarioCommandV1: result.invoke,
		invokingCreateCorporateScenarioCommandV1: result.invoking,
		succeedCreateCorporateScenarioCommandV1: result.succeed,
		validationErrorsCreateCorporateScenarioCommandV1: result.validationErrors,
		onSucceedCreateCorporateScenarioCommandV1: result.onSucceed,
	}
}

export function useDeleteCorporateScenarioCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.DeleteCorporateScenarioCommandV1(_workspaceId.value, _strategyId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedDeleteCorporateScenarioCommandV1: result.authorized,
		deleteCorporateScenarioCommandV1: result.command,
		completedDeleteCorporateScenarioCommandV1: result.completed,
		errorDeleteCorporateScenarioCommandV1: result.error,
		invokeDeleteCorporateScenarioCommandV1: result.invoke,
		invokingDeleteCorporateScenarioCommandV1: result.invoking,
		succeedDeleteCorporateScenarioCommandV1: result.succeed,
		validationErrorsDeleteCorporateScenarioCommandV1: result.validationErrors,
		onSucceedDeleteCorporateScenarioCommandV1: result.onSucceed,
	}
}

export function useOptimizeCorporateScenarioScheduleCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	minStartDate?: any | Ref<any> | (() => any), 
	maxStartDate?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _minStartDate = isRef<any>(minStartDate) ? minStartDate : ref<any>((typeof minStartDate === 'function') ? minStartDate() : minStartDate)
	const _maxStartDate = isRef<any>(maxStartDate) ? maxStartDate : ref<any>((typeof maxStartDate === 'function') ? maxStartDate() : maxStartDate)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		minStartDate: _minStartDate,
		maxStartDate: _maxStartDate,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof minStartDate === 'function') { _minStartDate.value = minStartDate() }
			if (typeof maxStartDate === 'function') { _maxStartDate.value = maxStartDate() }

			return new c.OptimizeCorporateScenarioScheduleCommandV1(_workspaceId.value, _strategyId.value, _id.value, _minStartDate.value, _maxStartDate.value)
		})
	}

	return {
		...result,
		authorizedOptimizeCorporateScenarioScheduleCommandV1: result.authorized,
		optimizeCorporateScenarioScheduleCommandV1: result.command,
		completedOptimizeCorporateScenarioScheduleCommandV1: result.completed,
		errorOptimizeCorporateScenarioScheduleCommandV1: result.error,
		invokeOptimizeCorporateScenarioScheduleCommandV1: result.invoke,
		invokingOptimizeCorporateScenarioScheduleCommandV1: result.invoking,
		succeedOptimizeCorporateScenarioScheduleCommandV1: result.succeed,
		validationErrorsOptimizeCorporateScenarioScheduleCommandV1: result.validationErrors,
		onSucceedOptimizeCorporateScenarioScheduleCommandV1: result.onSucceed,
	}
}

export function useSetPortfolioCapexLimitCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	portfolioId?: string | Ref<string> | (() => string), 
	limit?: number | null | Ref<number | null> | (() => number | null), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _limit = isRef<number | null>(limit) ? limit : ref<number | null>((typeof limit === 'function') ? limit() : limit)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		portfolioId: _portfolioId,
		limit: _limit,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof limit === 'function') { _limit.value = limit() }

			return new c.SetPortfolioCapexLimitCommandV1(_workspaceId.value, _strategyId.value, _id.value, _portfolioId.value, _limit.value)
		})
	}

	return {
		...result,
		authorizedSetPortfolioCapexLimitCommandV1: result.authorized,
		setPortfolioCapexLimitCommandV1: result.command,
		completedSetPortfolioCapexLimitCommandV1: result.completed,
		errorSetPortfolioCapexLimitCommandV1: result.error,
		invokeSetPortfolioCapexLimitCommandV1: result.invoke,
		invokingSetPortfolioCapexLimitCommandV1: result.invoking,
		succeedSetPortfolioCapexLimitCommandV1: result.succeed,
		validationErrorsSetPortfolioCapexLimitCommandV1: result.validationErrors,
		onSucceedSetPortfolioCapexLimitCommandV1: result.onSucceed,
	}
}

export function useSetPortfolioExpensesLimitCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	portfolioId?: string | Ref<string> | (() => string), 
	limit?: number | null | Ref<number | null> | (() => number | null), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _limit = isRef<number | null>(limit) ? limit : ref<number | null>((typeof limit === 'function') ? limit() : limit)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		portfolioId: _portfolioId,
		limit: _limit,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof limit === 'function') { _limit.value = limit() }

			return new c.SetPortfolioExpensesLimitCommandV1(_workspaceId.value, _strategyId.value, _id.value, _portfolioId.value, _limit.value)
		})
	}

	return {
		...result,
		authorizedSetPortfolioExpensesLimitCommandV1: result.authorized,
		setPortfolioExpensesLimitCommandV1: result.command,
		completedSetPortfolioExpensesLimitCommandV1: result.completed,
		errorSetPortfolioExpensesLimitCommandV1: result.error,
		invokeSetPortfolioExpensesLimitCommandV1: result.invoke,
		invokingSetPortfolioExpensesLimitCommandV1: result.invoking,
		succeedSetPortfolioExpensesLimitCommandV1: result.succeed,
		validationErrorsSetPortfolioExpensesLimitCommandV1: result.validationErrors,
		onSucceedSetPortfolioExpensesLimitCommandV1: result.onSucceed,
	}
}

export function useSetPortfolioOpexExpensesLimitCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	portfolioId?: string | Ref<string> | (() => string), 
	limit?: number | null | Ref<number | null> | (() => number | null), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _limit = isRef<number | null>(limit) ? limit : ref<number | null>((typeof limit === 'function') ? limit() : limit)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		portfolioId: _portfolioId,
		limit: _limit,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof limit === 'function') { _limit.value = limit() }

			return new c.SetPortfolioOpexExpensesLimitCommandV1(_workspaceId.value, _strategyId.value, _id.value, _portfolioId.value, _limit.value)
		})
	}

	return {
		...result,
		authorizedSetPortfolioOpexExpensesLimitCommandV1: result.authorized,
		setPortfolioOpexExpensesLimitCommandV1: result.command,
		completedSetPortfolioOpexExpensesLimitCommandV1: result.completed,
		errorSetPortfolioOpexExpensesLimitCommandV1: result.error,
		invokeSetPortfolioOpexExpensesLimitCommandV1: result.invoke,
		invokingSetPortfolioOpexExpensesLimitCommandV1: result.invoking,
		succeedSetPortfolioOpexExpensesLimitCommandV1: result.succeed,
		validationErrorsSetPortfolioOpexExpensesLimitCommandV1: result.validationErrors,
		onSucceedSetPortfolioOpexExpensesLimitCommandV1: result.onSucceed,
	}
}

export function useSetPortfolioOpexLimitCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	portfolioId?: string | Ref<string> | (() => string), 
	limit?: number | null | Ref<number | null> | (() => number | null), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _limit = isRef<number | null>(limit) ? limit : ref<number | null>((typeof limit === 'function') ? limit() : limit)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		portfolioId: _portfolioId,
		limit: _limit,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof limit === 'function') { _limit.value = limit() }

			return new c.SetPortfolioOpexLimitCommandV1(_workspaceId.value, _strategyId.value, _id.value, _portfolioId.value, _limit.value)
		})
	}

	return {
		...result,
		authorizedSetPortfolioOpexLimitCommandV1: result.authorized,
		setPortfolioOpexLimitCommandV1: result.command,
		completedSetPortfolioOpexLimitCommandV1: result.completed,
		errorSetPortfolioOpexLimitCommandV1: result.error,
		invokeSetPortfolioOpexLimitCommandV1: result.invoke,
		invokingSetPortfolioOpexLimitCommandV1: result.invoking,
		succeedSetPortfolioOpexLimitCommandV1: result.succeed,
		validationErrorsSetPortfolioOpexLimitCommandV1: result.validationErrors,
		onSucceedSetPortfolioOpexLimitCommandV1: result.onSucceed,
	}
}

export function useSetPortfolioOthexLimitCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	portfolioId?: string | Ref<string> | (() => string), 
	limit?: number | null | Ref<number | null> | (() => number | null), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _limit = isRef<number | null>(limit) ? limit : ref<number | null>((typeof limit === 'function') ? limit() : limit)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		portfolioId: _portfolioId,
		limit: _limit,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof limit === 'function') { _limit.value = limit() }

			return new c.SetPortfolioOthexLimitCommandV1(_workspaceId.value, _strategyId.value, _id.value, _portfolioId.value, _limit.value)
		})
	}

	return {
		...result,
		authorizedSetPortfolioOthexLimitCommandV1: result.authorized,
		setPortfolioOthexLimitCommandV1: result.command,
		completedSetPortfolioOthexLimitCommandV1: result.completed,
		errorSetPortfolioOthexLimitCommandV1: result.error,
		invokeSetPortfolioOthexLimitCommandV1: result.invoke,
		invokingSetPortfolioOthexLimitCommandV1: result.invoking,
		succeedSetPortfolioOthexLimitCommandV1: result.succeed,
		validationErrorsSetPortfolioOthexLimitCommandV1: result.validationErrors,
		onSucceedSetPortfolioOthexLimitCommandV1: result.onSucceed,
	}
}

export function useSetPortfolioResourceAllocationCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	portfolioId?: string | Ref<string> | (() => string), 
	resourceId?: string | Ref<string> | (() => string), 
	allocation?: number | null | Ref<number | null> | (() => number | null), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _resourceId = isRef<string>(resourceId) ? resourceId : ref<string>((typeof resourceId === 'function') ? resourceId() : resourceId)
	const _allocation = isRef<number | null>(allocation) ? allocation : ref<number | null>((typeof allocation === 'function') ? allocation() : allocation)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		portfolioId: _portfolioId,
		resourceId: _resourceId,
		allocation: _allocation,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof resourceId === 'function') { _resourceId.value = resourceId() }
			if (typeof allocation === 'function') { _allocation.value = allocation() }

			return new c.SetPortfolioResourceAllocationCommandV1(_workspaceId.value, _strategyId.value, _id.value, _portfolioId.value, _resourceId.value, _allocation.value)
		})
	}

	return {
		...result,
		authorizedSetPortfolioResourceAllocationCommandV1: result.authorized,
		setPortfolioResourceAllocationCommandV1: result.command,
		completedSetPortfolioResourceAllocationCommandV1: result.completed,
		errorSetPortfolioResourceAllocationCommandV1: result.error,
		invokeSetPortfolioResourceAllocationCommandV1: result.invoke,
		invokingSetPortfolioResourceAllocationCommandV1: result.invoking,
		succeedSetPortfolioResourceAllocationCommandV1: result.succeed,
		validationErrorsSetPortfolioResourceAllocationCommandV1: result.validationErrors,
		onSucceedSetPortfolioResourceAllocationCommandV1: result.onSucceed,
	}
}

export function useSetPortfolioTotalCostLimitCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	portfolioId?: string | Ref<string> | (() => string), 
	limit?: number | null | Ref<number | null> | (() => number | null), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _limit = isRef<number | null>(limit) ? limit : ref<number | null>((typeof limit === 'function') ? limit() : limit)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		portfolioId: _portfolioId,
		limit: _limit,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof limit === 'function') { _limit.value = limit() }

			return new c.SetPortfolioTotalCostLimitCommandV1(_workspaceId.value, _strategyId.value, _id.value, _portfolioId.value, _limit.value)
		})
	}

	return {
		...result,
		authorizedSetPortfolioTotalCostLimitCommandV1: result.authorized,
		setPortfolioTotalCostLimitCommandV1: result.command,
		completedSetPortfolioTotalCostLimitCommandV1: result.completed,
		errorSetPortfolioTotalCostLimitCommandV1: result.error,
		invokeSetPortfolioTotalCostLimitCommandV1: result.invoke,
		invokingSetPortfolioTotalCostLimitCommandV1: result.invoking,
		succeedSetPortfolioTotalCostLimitCommandV1: result.succeed,
		validationErrorsSetPortfolioTotalCostLimitCommandV1: result.validationErrors,
		onSucceedSetPortfolioTotalCostLimitCommandV1: result.onSucceed,
	}
}

export function useUpdateActivePortfolioScenarioCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	portfolioId?: string | Ref<string> | (() => string), 
	portfolioScenarioId?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _portfolioScenarioId = isRef<string>(portfolioScenarioId) ? portfolioScenarioId : ref<string>((typeof portfolioScenarioId === 'function') ? portfolioScenarioId() : portfolioScenarioId)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		portfolioId: _portfolioId,
		portfolioScenarioId: _portfolioScenarioId,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof portfolioScenarioId === 'function') { _portfolioScenarioId.value = portfolioScenarioId() }

			return new c.UpdateActivePortfolioScenarioCommandV1(_workspaceId.value, _strategyId.value, _id.value, _portfolioId.value, _portfolioScenarioId.value)
		})
	}

	return {
		...result,
		authorizedUpdateActivePortfolioScenarioCommandV1: result.authorized,
		updateActivePortfolioScenarioCommandV1: result.command,
		completedUpdateActivePortfolioScenarioCommandV1: result.completed,
		errorUpdateActivePortfolioScenarioCommandV1: result.error,
		invokeUpdateActivePortfolioScenarioCommandV1: result.invoke,
		invokingUpdateActivePortfolioScenarioCommandV1: result.invoking,
		succeedUpdateActivePortfolioScenarioCommandV1: result.succeed,
		validationErrorsUpdateActivePortfolioScenarioCommandV1: result.validationErrors,
		onSucceedUpdateActivePortfolioScenarioCommandV1: result.onSucceed,
	}
}

export function useUpdateCorporateScenarioCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	planningStartDate?: any | Ref<any> | (() => any), 
	planningEndDate?: any | Ref<any> | (() => any), 
	denomination?: any | Ref<any> | (() => any), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
	benefitsConfidenceDate?: any | null | Ref<any | null> | (() => any | null), 
	portfolioIds?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _planningStartDate = isRef<any>(planningStartDate) ? planningStartDate : ref<any>((typeof planningStartDate === 'function') ? planningStartDate() : planningStartDate)
	const _planningEndDate = isRef<any>(planningEndDate) ? planningEndDate : ref<any>((typeof planningEndDate === 'function') ? planningEndDate() : planningEndDate)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)
	const _benefitsConfidenceDate = isRef<any | null>(benefitsConfidenceDate) ? benefitsConfidenceDate : ref<any | null>((typeof benefitsConfidenceDate === 'function') ? benefitsConfidenceDate() : benefitsConfidenceDate)
	const _portfolioIds = isRef<any>(portfolioIds) ? portfolioIds : ref<any>((typeof portfolioIds === 'function') ? portfolioIds() : portfolioIds)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		planningStartDate: _planningStartDate,
		planningEndDate: _planningEndDate,
		denomination: _denomination,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,
		benefitsConfidenceDate: _benefitsConfidenceDate,
		portfolioIds: _portfolioIds,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof planningStartDate === 'function') { _planningStartDate.value = planningStartDate() }
			if (typeof planningEndDate === 'function') { _planningEndDate.value = planningEndDate() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }
			if (typeof benefitsConfidenceDate === 'function') { _benefitsConfidenceDate.value = benefitsConfidenceDate() }
			if (typeof portfolioIds === 'function') { _portfolioIds.value = portfolioIds() }

			return new c.UpdateCorporateScenarioCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _planningStartDate.value, _planningEndDate.value, _denomination.value, _applyBenefitsConfidenceFactor.value, _benefitsConfidenceDate.value, _portfolioIds.value)
		})
	}

	return {
		...result,
		authorizedUpdateCorporateScenarioCommandV1: result.authorized,
		updateCorporateScenarioCommandV1: result.command,
		completedUpdateCorporateScenarioCommandV1: result.completed,
		errorUpdateCorporateScenarioCommandV1: result.error,
		invokeUpdateCorporateScenarioCommandV1: result.invoke,
		invokingUpdateCorporateScenarioCommandV1: result.invoking,
		succeedUpdateCorporateScenarioCommandV1: result.succeed,
		validationErrorsUpdateCorporateScenarioCommandV1: result.validationErrors,
		onSucceedUpdateCorporateScenarioCommandV1: result.onSucceed,
	}
}

